import React, { createContext, PropsWithChildren, useContext } from 'react';
import { ServerFeatures } from '../../models/enums';
import { FALLBACK_RATINGS_VISIBILITY_THREASHOLD } from '../../utils/constants';
import { useFetchRatingsAndReviewsFeatureQuery } from '../../redux/api/appMarket-api-slice';
import { NormalizedServerFeature } from '../../models/app';
import { parseAndNormalizeServerFeature } from '../../utils/transformationHelper';

const defaultValue: NormalizedServerFeature = {
  id: '',
  name: ServerFeatures.RatingsAndReviews,
  enabled: true,
  isGloballyWhitelisted: true,
  blacklistedApps: {},
  blacklistedDevelopers: {},
  visibilityThreshold: FALLBACK_RATINGS_VISIBILITY_THREASHOLD
};

export const RatingsAndReviewsContext = createContext<NormalizedServerFeature>(defaultValue);
RatingsAndReviewsContext.displayName = 'RatingsAndReviews';
export const useRatingsAndReviews = () => useContext(RatingsAndReviewsContext);

let ratingsAndReviewsContextData: NormalizedServerFeature;

export const RatingsAndReviewsProvider : React.FC<PropsWithChildren<{}>> = (props : PropsWithChildren<{}>) : JSX.Element => {
  const { children } = props;

  const { data : ratingsAndReviewsFeatureData, isLoading } = useFetchRatingsAndReviewsFeatureQuery(undefined, { skip: !!ratingsAndReviewsContextData });
  if(!isLoading && !ratingsAndReviewsContextData && ratingsAndReviewsFeatureData) {
    ratingsAndReviewsContextData = parseAndNormalizeServerFeature(ratingsAndReviewsFeatureData);
    ratingsAndReviewsContextData.visibilityThreshold = typeof ratingsAndReviewsContextData.visibilityThreshold === 'number'? ratingsAndReviewsContextData.visibilityThreshold : FALLBACK_RATINGS_VISIBILITY_THREASHOLD ;
    ratingsAndReviewsContextData.isGloballyWhitelisted = !!ratingsAndReviewsContextData.isGloballyWhitelisted;
  }

  let value = ratingsAndReviewsContextData || defaultValue;
  return (
    <RatingsAndReviewsContext.Provider value={value}>
      {children}
    </RatingsAndReviewsContext.Provider>
  );
};
